import { render, staticRenderFns } from "./Kamishibai.vue?vue&type=template&id=10759d24&shadow"
import script from "./Kamishibai.vue?vue&type=script&lang=ts&shadow"
export * from "./Kamishibai.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./Kamishibai.vue?vue&type=style&index=0&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

component.options.__file = "Kamishibai.vue"
export default component.exports